import React from 'react';
import { Button, Tooltip, ButtonProps } from 'antd';
interface ActionButtonProps extends ButtonProps {
	tooltip?: string;
	name?: string;
}

const ActionButton: React.FC<ActionButtonProps> = ({ children, tooltip, disabled, ...props }) => {
	return (
		<Tooltip title={tooltip}>
			<span className='w-full'>
				<Button {...props} disabled={disabled}>
					{children}
				</Button>
			</span>
		</Tooltip>
	);
};

export default ActionButton;
